import {
  Button,
  ButtonGroup,
  colors,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Typography,
  GridList,
  GridListTile,
  GridListTileBar,
  IconButton
} from '@material-ui/core';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import DescriptionIcon from '@material-ui/icons/Description';
import PhotoIcon from '@material-ui/icons/Photo';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import React from 'react';
import 'react-confirm-alert/src/react-confirm-alert.css';
import axios from 'src/utils/axios';
import { deleteFotografWithId } from 'src/utils/storage/StrPhoto';
import { useTranslation } from 'react-i18next';
import { getUser } from 'src/utils/Common';
const useStyles = makeStyles(theme => ({
  root: {},
  dropZone: {
    border: `1px dashed ${theme.palette.divider}`,
    padding: theme.spacing(6),
    outline: 'none',
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    alignItems: 'center',
    '&:hover': {
      backgroundColor: colors.grey[50],
      opacity: 0.5,
      cursor: 'pointer'
    }
  },
  dragActive: {
    backgroundColor: colors.grey[50],
    opacity: 0.5
  },
  info: {
    marginTop: theme.spacing(1)
  },
  list: {
    maxHeight: 320
  },
  actions: {
    marginTop: theme.spacing(2),
    display: 'flex',
    justifyContent: 'flex-end',
    '& > * + *': {
      marginLeft: theme.spacing(2)
    }
  },
  icon: {
    color: 'white'
  },
  image: {
    position: 'relative',
    height: 130,
    [theme.breakpoints.down('xs')]: {
      width: '100% !important', // Overrides inline-style
      height: 100
    },
    '&:hover, &$focusVisible': {
      zIndex: 1,
      '& $imageBackdrop': {
        opacity: 0.15
      },
      '& $imageMarked': {
        opacity: 0
      },
      '& $imageTitle': {
        border: '4px solid currentColor'
      }
    }
  },
  focusVisible: {},
  imageButton: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.common.white
  },
  imageSrc: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundSize: 'cover',
    backgroundPosition: 'center 40%'
  },
  imageBackdrop: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundColor: theme.palette.common.black,
    opacity: 0.4,
    transition: theme.transitions.create('opacity')
  },
  imageTitle: {
    position: 'relative',
    padding: `${theme.spacing(2)}px ${theme.spacing(4)}px ${theme.spacing(1) +
      6}px`
  },
  imageMarked: {
    height: 3,
    width: 18,
    backgroundColor: theme.palette.common.white,
    position: 'absolute',
    bottom: -2,
    left: 'calc(50% - 9px)',
    transition: theme.transitions.create('opacity')
  },
  imageFull: {
    marginTop: theme.spacing(2),
    width: '100%'
  }
}));

function FilesPreview({
  className,
  ReceiptNo,
  WorkGuid,
  dataUri,
  files,
  readonly,
  fetchPhotos,
  setLoading
}) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [openError, setOpenError] = React.useState(false);
  const locale = localStorage.getItem('i18nextLng');
  const [Uyari, setUyari] = React.useState('');
  const [uyariTip, setUyariTip] = React.useState();
  const [fileTypes, setFileTypes] = React.useState('');
  const { t } = useTranslation('work_order');
  const SessionUser = getUser();
  const handleDetayAc = (event, dosya) => {
    if (dosya.Id < 0) {
      const image = new Image();
      image.src = dosya.FileData;
      const w = window.open('');
      w.document.write(image.outerHTML);
    } else {
      setLoading(true);
      const config = {
        responseType: 'blob'
      };
      const newWindow = window.open();
      axios
        .get(`/FileImportExport/SiriusFileDetail/${dosya.Id}`, config)
        .then(response => {
          // openBlob(response.data, dosya.FileName);
          const fileURL = URL.createObjectURL(response.data);
          newWindow.location = fileURL;
          newWindow.document.title = dosya.FileName;
          setLoading(false);
        })
        .catch(error => {
          setLoading(false);
        });
    }
  };

  const handleDelete = (event, DosyaId, DosyaReceiptNo) => {
    if (DosyaId < 0) {
      deleteFotografWithId(DosyaId);
      fetchPhotos(true);
    } else {
      axios
        .get(`/DeleteSiriusFile/${DosyaId}/${DosyaReceiptNo}`)
        .then(response => {
          const res = response.data;
          if (res == 0) {
            console.log(res)
            const informationAlert = res;
            setUyari(informationAlert);
            setOpen(true);
            fetchPhotos(true);
          }
          else {
            setOpenError(true);
            fetchPhotos(true);
          }

        })
        .catch(error => {
          fetchPhotos(true);
        });
    }
  };

  const Onizleme = (event, ciktiTipi) => {
    let Link = process.env.REACT_APP_CIKTI_URL;
    Link = `${Link}ServicePaper.html?WorkId=${WorkGuid}` + '&TenantId=' + SessionUser.TenantId + '&LanguageId=' + localStorage.getItem('i18nextLng');
    event.persist();
    window.open(Link);
    event.persist();
  };


  const handleClose = () => {
    setOpen(false);
  };

  const handleCloseError = () => {
    setOpenError(false);
  };

  const getFileList = () => {
    setLoading(true);
    axios
      .get(
        `/GetFileList/${ReceiptNo}`
      )
      .then(response => {
        if (response.data.length > 0 && response.data != "") {
          setFileTypes(response.data);
        } else {
          setFileTypes([]); //no data
        }
        setLoading(false);
      })
      .catch(error => {
        setUyariTip('error');
        setUyari(true);
        setLoading(false);
      });
  };

  useEffect(() => {
    getFileList();
  }, [locale])


  return (
    <div className={clsx(classes.root, className)}>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">
          {t('Bilgilendirme')}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {t('lblBasarili')}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            {t('Tamam')}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openError}
        onClose={handleCloseError}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">
          {t('Bilgilendirme')}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {t('lblDeleteError')}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseError} color="primary">
            {t('Tamam')}
          </Button>
        </DialogActions>
      </Dialog>


      <GridList cellHeight={150} className={classes.gridList}>
        <GridListTile>
          <IconButton
            onClick={(e) => Onizleme(e, 1)}
          >
            <DescriptionIcon fontSize="large" style={{ color: 'green' }} />
          </IconButton>
          <GridListTileBar
            title={t('lblPrint')}
          />
        </GridListTile>
      </GridList>
      {files.length > 0 && (
        <>
          <GridList cellHeight={150} className={classes.gridList}>
            {files.map(tile => (
              <GridListTile key={tile.Id}>
                <Grid container direction='row' justifyContent='center' spacing={1}>
                  <Grid item xs={2} sm={2} lg={2}>
                    <IconButton
                      onClick={event => handleDetayAc(event, tile)}
                      aria-label={`büyük resim ${tile.FileName}`}
                    >
                      {tile.FileType === 'image/jpeg' ||
                        tile.FileType === 'image/png' ||
                        tile.FileType === 'image/gif' ? (
                        <PhotoIcon style={{ color: '#AA5656' }} fontSize="large" className={classes.imageFull} />
                      ) : tile.FileType === 'application/pdf' ? (
                        <PictureAsPdfIcon style={{ color: '#AA5656' }} fontSize="large" />
                      ) : (
                        <DescriptionIcon style={{ color: '#AA5656' }} fontSize="large" />
                      )}
                    </IconButton>
                  </Grid>
                  <Grid item xs={10} sm={10} lg={10}>
                    {console.log(fileTypes)}
                    {Array.isArray(fileTypes) && fileTypes?.filter(index => index.Id == tile.Id).map(fileteredTypleList => (
                      <Typography style={{ color: '#AA5656', marginTop: '25px' }} variant="overline" display="block" gutterBottom>{fileteredTypleList.TypeName}</Typography>
                    ))}
                  </Grid>
                </Grid>
                <GridListTileBar
                  title={tile.FileName}
                  subtitle={
                    <span>{tile.FileType + (tile.Id < 0 ? ' Lokal' : '')}</span>
                  }
                  actionIcon={
                    <ButtonGroup
                      color="primary"
                      aria-label="outlined primary button group"
                    >
                      <IconButton
                        onClick={event =>
                          handleDelete(event, tile.Id, tile.WorkOrderId)
                        }
                        aria-label={`Delete ${tile.FileName}`}
                        className={classes.icon}
                        disabled={readonly}
                      >
                        <DeleteForeverIcon color="error" />
                      </IconButton>
                    </ButtonGroup>
                  }
                />
              </GridListTile>
            ))}
          </GridList>
        </>
      )}
    </div>
  );
}
FilesPreview.propTypes = {
  className: PropTypes.string
};

export default FilesPreview;
